import format from 'date-fns/format';
import addMinutes from 'date-fns/addMinutes';
import isToday from 'date-fns/isToday';
import esLocale from 'date-fns/locale/es';

(window as any).aaa = format;

export function getRelativeTimeInfo(date: any) {
  if (!date) return undefined;

  if (isToday(date)) {
    return format(date, 'h:mm aaa');
  }

  return format(date, 'yyyy-MM-dd');
}

export function getFormattedDate(date: any) {
  if (!date) return undefined;

  return date.split('T')[0]; // yyyy-MM-dd
}

export function getFormattedTimeFromMinutes(minutes: number) {
  const hour = `${Math.floor(minutes / 60)}`.padStart(2, '0');
  const minute = `${minutes % 60}`.padStart(2, '0');
  return `${hour}:${minute}`;
}

export function getFormattedMeetingDate(isoDate: string, interval: number) {
  try {
    const dateInfo = isoDate.split('.')[0].split('T');
    const date = dateInfo[0];
    const hour = dateInfo[1];
    const meetingStart = new Date(`${date}:${hour}`);
    const meetingEnd = addMinutes(meetingStart, interval);

    return `${format(new Date(`${date}:${hour}`), 'PP', {
      locale: esLocale,
    })}, ${format(meetingStart, 'HH:mm')}/${format(meetingEnd, 'HH:mm')}`;
  } catch (e) {
    return '';
  }
}

export function getLocaleDate(date: Date | string) {
  return format(
    typeof date === 'string' ? new Date(date) : date,
    'd MMM, yyyy',
    {
      locale: esLocale,
    }
  );
}
